import React from 'react';
import { Card } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import { ContactInformation } from './ContactInformation';

interface ProfileConfigProps {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  isOnboarding?: boolean;
}

export const ProfileConfig: React.FC<ProfileConfigProps> = React.memo(({
  firstName,
  lastName,
  email,
  phone,
  isOnboarding = false,
}) => {
  return (
    <Card className="animate-fade-in p-3 pb-16 space-y-3 sm:p-6 sm:space-y-6">
      <ContactInformation firstName={firstName} lastName={lastName} email={email} phone={phone} isOnboarding={isOnboarding} />
    </Card>
  );
});

ProfileConfig.displayName = 'ProfileConfig';
